export default [  
  {
    path: '/roles',
    name: 'roles',
    component: () => import('@/views/modules/roles/list'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      breadcrumb: [
        { text: 'Dashboard',  to: { name: "dashboard" } },
        { text: 'Roles' }
      ]
    },
    children:[
      {
        path: '/roles/create',
        name: 'roles-create',
        component: () => import('@/views/modules/roles/create'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          breadcrumb: [
            { text: 'Dashboard',  to: { name: "dashboard" } },
            { text: 'Roles', link: '/roles' },
            { text: 'Create' }
          ]
        }
      },
      {
        path: '/roles/:id/edit',
        props: true,
        name: 'roles-edit',
        component: () => import('@/views/modules/roles/edit'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          breadcrumb: [
            { text: 'Dashboard',  to: { name: "dashboard" } },
            { text: 'Role',  to: { name: "roles-show" }, param: 'id' },
            { text: 'Edit' }
          ]
        }
      },
      {
        path: '/roles/:id/show',
        props: true,
        name: 'roles-show',
        component: () => import('@/views//modules/roles/show'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          breadcrumb: [
            { text: 'Dashboard',  to: { name: "dashboard" } },
            { text: 'Roles',  to: { name: "roles" } },
            { text: 'Details' }
          ]
        }
      },
    
    ]
  },
 
]